import React from 'react';
import { FormGroup, ToggleButton } from '@mui/material';
import { Box } from '@mui/system';
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from 'react-redux';
import { uploadTraitStrengthMapping } from '../../redux/slices/onboarding/onboardingThunk';
import { setPreviousAnswers, setQuestionnaire } from '../../redux/slices/onboarding/onboardingSlice';

const CheckboxQuestion = ({ pInd, qInd, answer }) => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const { questionnaire, previousAnswers } = useSelector(state => state.onboarding);

    const onClickCheckbox = async (e) => {
        e.preventDefault();
        const isAlreadySelected = answer?.selected;
        const tempPreviousAnswers = JSON.parse(JSON.stringify(previousAnswers));
        const tempQuestionnaire = JSON.parse(JSON.stringify(questionnaire));

        tempPreviousAnswers[answer.id] = !isAlreadySelected;
        dispatch(setPreviousAnswers(tempPreviousAnswers));

        tempQuestionnaire[pInd].SurveyQuestions[qInd].AnswerChoices.find((tempAnswer) => tempAnswer.id === answer.id).selected = !isAlreadySelected;
        dispatch(setQuestionnaire(tempQuestionnaire));

        dispatch(uploadTraitStrengthMapping({ previousAnswers: tempPreviousAnswers, questionnaire: tempQuestionnaire, pageIndex: pInd }));
    }

    return (
        <Box aria-label="checkbox-question-wrapper">
            <FormGroup
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}
            >
                <ToggleButton 
                    key={answer.id}
                    selected={previousAnswers[answer.id]}
                    onClick={async (e) => await onClickCheckbox(e)}
                    sx={{
                        margin: "0.5rem",
                        backgroundColor: theme.palette.caralystRed.dark,
                        width: '40vw',
                        minWidth: "18rem",
                        maxWidth: "25rem",
                        color: "white",
                        transition: "background-color 0.15s ease-in-out",
                        textTransform: "none",
                        fontSize: "1.2em",
                        '&:hover': {
                            backgroundColor: theme.palette.caralystRed.main,
                            color: "white",
                        },
                        '&.Mui-selected': {
                            backgroundColor: theme.palette.caralystRed.main,
                            color: "white",
                        },
                        '&.Mui-selected:hover': {
                            backgroundColor: theme.palette.caralystRed.main,
                            color: "white",
                        }
                    }}
                >
                    {answer.text}
                </ToggleButton>
            </FormGroup>
        </Box>
    );
}

export default CheckboxQuestion;